import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';

declare var $: any;

@Directive({
    selector: '[appHighlight]'
})
export class ScheduleDirective implements OnChanges, OnInit {
    @Input() dates: any;
    @Input() ngModel: any;
    @Input() matrix: any;
    @Input() id: string;

    @Output() public onTimingChanged = new EventEmitter<any>();

    private wrapper: any;
    private dp: any;

    constructor(
        private el: ElementRef,
        private ngZone: NgZone
    ) {
        this.wrapper = el.nativeElement;
    }

    ngOnInit() {
        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => this.initializePlugin(), 0);
        });
    }

    private initializePlugin() {
        if (this.dp) {
            this.dp.initializeAgain(this.dates, this.matrix);
        } else if (this.dates && this.dates.startDate != null && this.dates.endDate != null) {
            this.dp = $(this.wrapper).ALDayParting({
                callback: () => this.ngZone.run(() => this.processChange()),
                startDate: this.dates.startDate,
                endDate: this.dates.endDate,
                id: this.id
            });
        }
    }

    private processChange() {
        setTimeout(() => {
            const dataResult = this.dp.getMatrixResult();
            this.onTimingChanged.emit(dataResult);
        }, 50);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.dates || changes.matrix) {
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() => this.initializePlugin(), 0);
            });
        }
    }
}
